/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".heading[_ngcontent-%COMP%]{font-size:16px;font-weight:700;line-height:2.5em}.after-login-background[_ngcontent-%COMP%]{background-color:var(--main-background-color)}.before-login-background[_ngcontent-%COMP%]{padding:80px 0;background-color:var(--auto-matching-tab-background-color)}"];
export { styles as styles };
